import { isPresent } from "legacy/helpers.es6"
import PropTypes from "prop-types"
import React from "react"

class BackOffRefresher extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      maxUpdatedAt: this.props.maxUpdatedAt,
      backoffMultiplier: 1,
    }
    this.runTimeout = this.runTimeout.bind(this)
  }

  componentDidMount() {
    this.runTimeout()
  }

  runTimeout() {
    setTimeout(
      () => {
        // Note: jQuery ($) is loaded globally
        $.post(
          this.props.refreshUrl,
          { max_updated_at: this.state.maxUpdatedAt },
          (data) => {
            if (isPresent(data) && Object.hasOwn(data, "max_updated_at")) {
              this.setState({
                maxUpdatedAt: data.max_updated_at,
                backoffMultiplier: 1,
              })
              $(this.props.htmlPath).html(data.html)
            }
          }
        )
        this.setState({ backoffMultiplier: this.state.backoffMultiplier * 2 })
        this.runTimeout()
      },
      this.state.backoffMultiplier * 5 * 1000
    )
  }

  render() {
    return null
  }
}

BackOffRefresher.propTypes = {
  maxUpdatedAt: PropTypes.number.isRequired,
  refreshUrl: PropTypes.string.isRequired,
  htmlPath: PropTypes.string.isRequired,
}

export default BackOffRefresher
